module.exports = __webpack_public_path__ + "static/media/OwnMoreThan25.bbfa02b1.svg";